import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {PortfolioProvider} from "./contexts/recentsWorks";
import {BrowserRouter as Router} from 'react-router-dom';
import {JobsProvider} from './contexts/recentJobs'


ReactDOM.render(
  <JobsProvider>
    <PortfolioProvider>
      <Router>
          <App/>
      </Router>
    </PortfolioProvider>
  </JobsProvider>
 ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
